namespace cdh.data {

    export interface IUserPropertyModel {
        //userInfo: IUserInfo;
        //notificationInfo: INotificationInfo;
    }

    //export interface IUserInfo {
    //    userCode: string;

    //    ownEmails: string[];
    //    excludeOwnEmails: string[];
    //}

    //export interface INotificationInfo {
    //    recipientAddress: string;
    //}

    export type UserPropertyBlock = {
        viewModel: any,
        template: DialogTemplate,
        label: ObservableOrValueReadonly<string>
    };

    var usrProps: IDialogOptions = {
        title: t2("userProperties/title"),
        //template: { type: "url", value: () => Router.action("Home", "UserProperties") },
        template: { type: "id", value: "templates/core/userProperties" },
        size: "default"
    };

    export function getUserImageUrl(id: number) {
        if (id) {
            return Router.action("User", "Image", { usrId: id });
        }
        return null;
    }

    function lineValueInterceptor(linesObs: KnockoutObservable<string[]>): KnockoutObservable<string> {
        return ko.pureComputed({
            read: () => {
                var res: string = "";
                var vals = linesObs();
                if (vals && vals.length)
                    for (var i = 0; i < vals.length; i++) {
                        if (i != 0) res += "\n";
                        res += vals[i];
                    }

                return res;
            },
            write: (val) => {
                var res: string[] = [];

                if (typeof (val) == "string" && val) {
                    var lines = val.split(/\r?\n/g);

                    res = lines;
                }

                linesObs(res);
            }
        });

    }

    //export class UserInfoViewModel extends viewModels.ViewModelBase<UserInfoViewModel, IUserInfo, UserPropertyEditorViewModel>{
    //    static props = new PropertyMapper<UserInfoViewModel>(["userCode", "ownEmails", "excludeOwnEmails"]);

    //    readonly userCode: KnockoutObservable<string>;
    //    readonly ownEmails: KnockoutObservable<string[]>;
    //    readonly excludeOwnEmails: KnockoutObservable<string[]>;
    //    readonly ownEmail: KnockoutObservable<string>;
    //    readonly excludeOwnEmail: KnockoutObservable<string>;


    //    constructor(parent: UserPropertyEditorViewModel) {
    //        super(UserInfoViewModel.props, parent, null);

    //        this.ownEmail = lineValueInterceptor(this.ownEmails);
    //        this.excludeOwnEmail = lineValueInterceptor(this.excludeOwnEmails);
    //    }

    //    getBlockDef(): UserPropertyBlock {
    //        return {
    //            viewModel: this,
    //            label: cdh.t2('userProperties/general/userInfo'),
    //            template: { type: "id", value: "templates/core/userProperties/userInfo" }
    //        }
    //    }
    //}

    //export class NotificationInfoViewModel extends viewModels.ViewModelBase<NotificationInfoViewModel, INotificationInfo, UserPropertyEditorViewModel>{
    //    static props = new PropertyMapper<NotificationInfoViewModel>(["recipientAddress"]);

    //    readonly recipientAddress: KnockoutObservable<string>;


    //    constructor(parent: UserPropertyEditorViewModel) {
    //        super(NotificationInfoViewModel.props, parent, null);
    //    }

    //    getBlockDef(): UserPropertyBlock {
    //        return {
    //            viewModel: this,
    //            label: cdh.t2('userProperties/general/notificationInfo'),
    //            template: { type: "id", value: "templates/core/userProperties/notificationInfo" }
    //        }
    //    }

    //}

    export class UserPropertyEditorViewModel extends viewModels.ViewModelBase<UserPropertyEditorViewModel, IUserPropertyModel>{
        static props = new PropertyMapper<UserPropertyEditorViewModel, IUserPropertyModel>([
            //{ name: "userInfo", handler: "block", type: UserInfoViewModel },
            //{ name: "notificationInfo", handler: "block", type: NotificationInfoViewModel }
        ]);

        readonly dialogResult = ko.observable<boolean>();
        readonly isBusy = utils.createBusyCounter();
        readonly errors = utils.getErrorList(true);
        readonly errorList = new viewModels.ErrorListWidget(this, this.errors);

        //readonly userInfo: UserInfoViewModel;
        //readonly notificationInfo: NotificationInfoViewModel;
        //readonly users: pm.UsersViewModel;

        readonly blocks: UserPropertyBlock[];

        constructor() {
            super(UserPropertyEditorViewModel.props, null, null);
            //this.users = new pm.UsersViewModel(null);
            //this.users.reload();

            this.blocks = [
                //this.userInfo.getBlockDef(),
                //this.notificationInfo.getBlockDef(),
            ]

            this.reload();

        }

        async reload() {
            if (this.isBusy()) return;

            let d = this.isBusy.beginUsing();
            try {
                var url = Router.action("UserProperty", "Get");

                var m = await utils.getSingle<IUserPropertyModel>(url);

                this.fromModel(m);
            }
            finally {
                d.dispose();
            }

        }

        async save() {
            if (this.isBusy()) return;

            let d = this.isBusy.beginUsing();
            try {
                var url = Router.action("UserProperty", "Post");

                var m = this.toModel();
                debugger;

                m = await utils.sendAjax({
                    url: url,
                    method: "PUT",
                    data: m,
                    errors: this.errors.handler
                });

                this.fromModel(m);
                this.dialogResult(true);
            }
            finally {
                d.dispose();
            }

        }

        showDialog() {
            return ui.showDialog(this, usrProps);
        }

    }


    export namespace apiUrls {
        export const apiBaseUrl = "api";


        export const controllerUrlBase = apiBaseUrl + "/{controller}";
        export const controllerIdUrlBase = controllerUrlBase + "/{id}";
        export const controllerActionUrlBase = controllerUrlBase + "/{action}";
        export const controllerIdActionUrlBase = controllerUrlBase + "/{id}/{action}";

        export const areaUrlBase = apiBaseUrl + "/{area}";
        export const areaControllerUrlBase = areaUrlBase + "/{controller}";
        export const areaControllerIdUrlBase = areaControllerUrlBase + "/{id}";
        export const areaControllerActionUrlBase = areaControllerUrlBase + "/{action}";
        export const areaControllerIdActionUrlBase = areaControllerUrlBase + "/{id}/{action}";

        export function getGenericRouteUrl(area: string, controller: string, rVals?: MappableObject) {
            var route: string;
            if (!rVals) rVals = {};

            rVals.controller = controller;
            if (area) {
                route = areaControllerUrlBase;
                rVals.area = area;

                if (rVals.id !== undefined) {
                    route = rVals.action === undefined ? areaControllerIdUrlBase : areaControllerIdActionUrlBase;
                } else if (rVals.action !== undefined)
                    route = areaControllerActionUrlBase;
            }
            else {
                route = controllerUrlBase;
                delete rVals.area;

                if (rVals.id !== undefined) {
                    route = rVals.action === undefined ? controllerIdUrlBase : controllerIdActionUrlBase;
                } else if (rVals.action !== undefined)
                    route = controllerActionUrlBase;
            }

            return utils.getUrl(route, rVals);
        }

        export class UrlHelper {

            constructor(readonly area: string, private readonly defaultRouteVals?: MappableObject) {

            }

            private extendRouteData(rVals: MappableObject, addArea?: boolean) {
                if (this.defaultRouteVals) {
                    if (!rVals) rVals = {};
                    utils.extend2(rVals, this.defaultRouteVals);
                }

                if (addArea && this.area) {
                    if (!rVals) rVals = {};
                    if (!rVals.area)
                        rVals.area = this.area;

                }

                return rVals;
            }

            getGenericRouteUrl(controller: string, rVals?: MappableObject): string {
                return getGenericRouteUrl(this.area, controller, this.extendRouteData(rVals));
            }

            getAction(controller: string, action: string, rVals?: MappableObject): string {
                return Router.action(controller, action, this.extendRouteData(rVals, true));
            }

            extend(rVals?: MappableObject) {
                return new UrlHelper(this.area, this.extendRouteData(rVals));
            }
        }
    }
}